<template>
  <MainLayout>
    <ReservationCancel />
  </MainLayout>
</template>

<script>
// @ is an alias to /src
import MainLayout from '@/layouts/MainLayout.vue';
import ReservationCancel from '@/components/reserve/ReservationCancel.vue';

export default {
  name: 'ReservationsView',
  components: {
    MainLayout,
    ReservationCancel,
  },
};
</script>
